import { useState, useEffect } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import methodModel from "../../methods/methods";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/global/layout";
import { Tooltip } from "antd";
import FormControl from "../../components/common/FormControl";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import environment from "../../environment";

const AddEditUser = () => {
  const { id } = useParams()
  const [form, setform] = useState({
    firstName: "",
    lastName: "",
    email: "",
    dialCode: "",
    mobileNo: ""
  })
  const history = useNavigate()
  const [submitted, setSubmitted] = useState(false)
  const inValidEmail = methodModel.emailvalidation(form?.email)

  useEffect(() => {
    if (id) {
      getUserDetail()
    }
  }, [])

  const getUserDetail = () => {
    loader(true);
    ApiClient.get(`user/profile?id=${id}`).then((res) => {
      if (res.success) {
        setform({
          ...form,
          firstName: res?.data?.firstName,
          lastName: res?.data?.lastName,
          email: res?.data?.email,
          dialCode: res?.data?.dialCode,
          fullName: res?.data?.fullName || "",
          mobileNo: res?.data?.mobileNo || "",
        })
      }
      else {
        toast?.error(res?.message)
      }
      loader(false);
    });
  }

  const handleChangePhone = (phone, country) => {
    const dialCode = country?.dialCode
    setform({ ...form, dialCode: dialCode, mobileNo: phone?.replace(dialCode, "") })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitted(true)
    if (!form?.mobileNo) return
    let method = "post"
    let url = "user/add"
    let value = {
      ...form,
      id: id || "",
    }
    if (id) {
      method = "put"
      url = "user/profile"
      delete value?.role
    } else {
      delete value.id
      value = { ...value, role: environment.userRole }
    }
    loader(true)
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        history(`/users`)
      }
      loader(false)
    })
  }

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit} autoComplete="one-time-code">
          <div className="pprofile1">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <Link
                  to={`/users`}
                  className="!px-4 py-2 flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3"
                >
                  <i className="fa fa-angle-left text-lg"></i>
                </Link>
              </Tooltip>
              <div>
                <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">{id ? "Edit" : "Add"} Sender</h3>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {id && form?.role?.value === environment.recipientRole ?
                <div className="mb-3">
                  <FormControl
                    type="text"
                    name="fullName"
                    label="Full Name"
                    placeholder="Full Name"
                    value={form?.fullName}
                    onChange={(e) => setform({ ...form, fullName: e })}
                    required
                  />
                </div>
                :
                <>
                  <div className="mb-3">
                    <FormControl
                      type="text"
                      name="firstName"
                      label="First Name"
                      placeholder="First Name"
                      value={form?.firstName}
                      onChange={(e) => setform({ ...form, firstName: e })}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <FormControl
                      type="text"
                      name="lastName"
                      label="Last Name"
                      placeholder="Last Name"
                      value={form?.lastName}
                      onChange={(e) => setform({ ...form, lastName: e })}
                      required
                    />
                  </div>
                </>
              }
              <div className=" mb-3">
                <FormControl
                  type="text"
                  name="email"
                  label="Email"
                  placeholder="Email"
                  value={form.email}
                  onChange={(e) => setform({ ...form, email: e })}
                  required
                  disabled={id ? true : false}
                />
                {form?.email && submitted && !inValidEmail && (
                  <div className="invalid-feedback d-block">
                    Please enter valid email
                  </div>
                )}
              </div>
              {/* <div className="mb-3">
                <label>Role <span className="text-red-600"> *</span></label>
                <Select
                  value={form?.role}
                  onChange={e => setform({ ...form, role: e })}
                  options={roles}
                  className="capitalize"
                  isDisabled={id}
                  required
                />
                {!form?.role?.value && submitted && (
                  <div className="invalid-feedback d-block">Role is required</div>
                )}
              </div> */}
              <div className="mobile_number">
                <label>Mobile number <span className="text-red-600"> *</span></label>
                <PhoneInput
                  placeholder="Mobile Number"
                  className="mobile-input"
                  value={form?.dialCode + form?.mobileNo}
                  enableSearch={true}
                  autocompleteSearch={false}
                  onChange={(phone, country) => handleChangePhone(phone, country)}
                  inputProps={{ required: true, autoComplete: "one-time-code" }}
                />
                {submitted && !form?.mobileNo && (
                  <div className="invalid-feedback d-block">Mobile is required</div>
                )}
              </div>
            </div>
            <div className="text-right">
              <button type="submit" className="text-white bg-[#F58D18] bg-[#F58D18] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
                {id ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditUser;
